import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICustomWindow, WindowRefService } from './window-ref.service';

interface IEventQueue {
    processQueue(): void;
}

@Injectable()
export abstract class TrackingService implements IEventQueue {
    protected _renderer?: Renderer2;
    protected _hasConsent = new BehaviorSubject<boolean>(false);

    protected get Window(): ICustomWindow | undefined {
        return this._windowRef.NativeWindow;
    }

    protected get hasConsent() {
        return this._hasConsent.getValue();
    }

    protected _rendererFactory = inject(RendererFactory2);
    private _windowRef = inject(WindowRefService);

    constructor() {
        if (!this.Window) return;

        this._renderer = this._rendererFactory.createRenderer(null, null);
        this._renderer.listen(this.Window, 'CookiebotOnConsentReady', () =>
            this._hasConsent.next(true)
        );

        this._hasConsent.subscribe((x: boolean) => {
            if (!x) return;

            this.processQueue();
        });
    }

    processQueue(): void {
        throw new Error('Method not implemented.');
    }
}
